module.exports = __webpack_public_path__ + "img/pr.5f66e57f.svg";